import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import classNames from "classnames";
import { Link, UploadCloud } from "lucide-react";
import React, { useEffect, useState } from "react";
import default_business_logo_placeholder from "../../assets/default-business-logo-placeholder.png";
import defaultImagesvg from "../../assets/defaultImagesvg.svg";
// import defaultImagesvg from "../../assets/placeholder.svg";
import Dropzone from "react-dropzone";
import TwLabel from "./TwLabel";
// import { handleUploadImageToS3 } from "../../helpers";
import axios from "axios";
import { getUrlForCronServer } from "../../utils/confighelpers";
import TwButton from "./TwButton";
import TwFormHelperText from "./TwFormHelperText";
import TwLoadingIcon from "./TwLoadingIcon";
// const axios = require('axios');
// const FormData = require('form-data');

export default function TwDropzone(props) {

  const { name = "", label = "", value = "", errors = {}, error = "", initialValue, defaultValue, uploadBtnText = "Change Logo", onChange, variant = "dropzone" } = props
  // const [imageUrl, setImageUrl] = useState(defaultImagesvg);
  // const [imageUrl, setImageUrl] = useState(defaultImagesvg);
  const acceptImageType = "image/jpeg, image/png, image/gif, image/webp"
  const [imageUrl, setImageUrl] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = React.useState(false);

  let inputLableClass = "text-black/[0.6]"
  let inputClass = "border-gray-200 outline-gray-200 hover:outline-indigo-bz focus-within:outline-indigo-bz"

  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "border-red-300 outline-red-300 placeholder:border-red-300 focus-within:outline-red-600"
  }

  const tabs = [
    { name: "Image URL", icon: Link },
    { name: "Upload Image", icon: UploadCloud },
  ];
  useEffect(() => {
    console.log("value", value);
    if (value) {

      setImageUrl(value.trim());
      setUploadedFile(null);
    }
  }, [value]);

  const uploadeMediaToServer = (file, cb) => {

    console.log("file", file);

    let data = new FormData();
    // const fsp = fs.promises;
    // data.append('file', fs.createReadStream(file.name));
    data.append('uploadingFor', 'TestClass');
    data.append('file', file);
    console.log("FormData", data);


    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${getUrlForCronServer()}media-upload`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data
    };
    setLoading(true)
    axios.request(config)
      .then((response) => {
        setLoading(false)
        console.log("response.data.url", response.data.url);
        console.log(JSON.stringify(response.data));
        if (response.data.url) {
          setUploadedFile(response.data.url);
          setImageUrl(response.data.url);
          if (onChange) onChange(response.data.url)
          if (cb) cb(true)
        } else {
          setUploadedFile("");
          setImageUrl("");
          if (onChange) onChange("")
          errors[name] = "Only PNG and JPG formats are allowed";
          if (cb) cb(false)
        }
      })
      .catch((error) => {
        console.log("error 123:", error);
        setLoading(false)
        if (error?.response?.data && error.response.data.error) {
          setUploadedFile("");
          setImageUrl("");
          if (onChange) onChange("")
          errors[name] = error.response.data.error;
        }
        if (cb) cb(false)
      });
  }

  return (
    <div className="space-y-4">
      {label && (<TwLabel error={errors[name] ? true : false}>{label}</TwLabel>)}
      {variant === "formData" ? (
        <div className="w-full sm:w-full sm:max-w-sm md:max-w-lg flex flex-col gap-2">

          {/* Preview */}
          <div className={classNames("border [border-gray-200] rounded-md p-4 bg-gray-50", inputClass)}>
            <p className="text-sm font-medium mb-2">Image Preview</p>
            <div className="w-full aspect-[2/1] bg-gray-100 flex items-center justify-center overflow-hidden rounded-md">
              {loading ? (
                <div className={"h-28 w-full grid place-items-center"}>
                  <TwLoadingIcon />
                </div>
              ) : (imageUrl ? (
                <img src={imageUrl} alt="Preview" className="object-contain h-full w-full" />
              ) : (
                <img src={defaultValue || defaultImagesvg} alt="Preview" className="object-contain h-full w-full" />
                // <span className="text-gray-400 text-sm">No image selected</span>
              ))}
            </div>
          </div>
          <Dropzone
            accept={acceptImageType}
            noDrag={true}
            onDrop={async (files) => {
              // const errors = {};
              errors[name] = undefined;
              if (files[0]) {
                const file = files[0];
                uploadeMediaToServer(file);
                return
              } else {
                setUploadedFile("");
                setImageUrl("");
                if (onChange) onChange("")
                errors[name] = "Only PNG and JPG formats are allowed";
              }
              // setFormErrors({ ...errors });
            }}
          >
            {({ getRootProps, getInputProps }) => {
              return (
                <div
                  {...getRootProps({ className: "dropzone" })}
                  className={classNames("flex space-x-1 rounded-md bg-gray-100 p-1",)}
                >
                  <div
                    className={
                      classNames(
                        "flex items-center gap-2 w-full justify-center rounded-md py-2 text-sm font-medium",
                        "bg-white shadow text-blue-600"
                      )
                    }
                  >
                    <UploadCloud className="w-4 h-4" />
                    Upload Image (Click here to upload)
                    {/* {loading ? (
                      <div className={"h-28 w-full grid place-items-center"}>
                        <TwLoadingIcon />
                      </div>
                    ) : (<>
                      <UploadCloud className="h-6 w-6" />
                      <p className="text-sm">Click or drag an image here to upload</p>
                      <p className="text-sm">JPEG, PNG, GIF up to 5MB</p>
                    </>)} */}
                    <input {...getInputProps()} />
                  </div>
                </div>
              );
            }}
          </Dropzone>

        </div>
      ) : (variant === "dropzone" ? (
        <div className="w-full sm:w-full sm:max-w-sm md:max-w-lg flex flex-col gap-2">

          {/* Preview */}
          <div className={classNames("border [border-gray-200] rounded-md p-4 bg-gray-50", inputClass)}>
            <p className="text-sm font-medium mb-2">Image Preview</p>
            <div className="w-full aspect-[2/1] bg-gray-100 flex items-center justify-center overflow-hidden rounded-md">
              {loading ? (
                <div className={"h-28 w-full grid place-items-center"}>
                  <TwLoadingIcon />
                </div>
              ) : (imageUrl ? (
                <img src={imageUrl} alt="Preview" className="object-contain h-full w-full" />
              ) : (
                <img src={defaultValue || defaultImagesvg} alt="Preview" className="object-contain h-full w-full" />
                // <span className="text-gray-400 text-sm">No image selected</span>
              ))}
            </div>
          </div>
          <Dropzone
            accept={acceptImageType}
            noDrag={true}
            onDrop={async (files) => {
              const errors = {};
              if (files[0]) {
                const file = files[0];
                uploadeMediaToServer(file);
                return;
                // // setImageProgress(Math.floor((Math.random() * 30) + 1));
                // setLoading(true)
                // const file = await handleUploadImageToS3(files[0]);
                // setLoading(false)
                // // setImageProgress(100);
                // if (file.result.ok) {
                //   setUploadedFile(file.location.trim());
                //   setImageUrl(file.location.trim());
                //   if (onChange) onChange(file.location.trim())
                // }
                // // setImageProgress(100);
              } else {
                setUploadedFile("");
                setImageUrl("");
                if (onChange) onChange("")
                errors[name] = "Only PNG and JPG formats are allowed";
              }
              // setFormErrors({ ...errors });
            }}
          >
            {({ getRootProps, getInputProps }) => {
              return (
                <div
                  {...getRootProps({ className: "dropzone" })}
                  className={classNames("flex space-x-1 rounded-md bg-gray-100 p-1",)}
                >
                  <div
                    className={
                      classNames(
                        "flex items-center gap-2 w-full justify-center rounded-md py-2 text-sm font-medium",
                        "bg-white shadow text-blue-600"
                      )
                    }
                  >
                    <UploadCloud className="w-4 h-4" />
                    Upload Image (Click here to upload)
                    {/* {loading ? (
                      <div className={"h-28 w-full grid place-items-center"}>
                        <TwLoadingIcon />
                      </div>
                    ) : (<>
                      <UploadCloud className="h-6 w-6" />
                      <p className="text-sm">Click or drag an image here to upload</p>
                      <p className="text-sm">JPEG, PNG, GIF up to 5MB</p>
                    </>)} */}
                    <input {...getInputProps()} />
                  </div>
                </div>
              );
              return (
                <div
                  {...getRootProps({ className: "dropzone" })}
                  className={classNames("relative w-full sm:w-full sm:max-w-sm md:max-w-lg min-h-60 border-2 border-dashed [border-gray-300] rounded-md p-6 text-center [bg-gray-50] hover:bg-gray-100 transition cursor-pointer flex flex-col gap-2 items-center justify-center",
                    inputClass,
                    imageUrl ? "bg-cover bg-center" : "bg-gray-50")}
                  style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : "none" }}
                >
                  <div
                    className={classNames("absolute inset-0 bg-gray-100/50  rounded-md [min-h-20] flex flex-col gap-2 items-center justify-center text-gray-500", loading === false && imageUrl ? "opacity-0 hover:opacity-100" : "")}
                  >
                    {loading ? (
                      <div className={"h-28 w-full grid place-items-center"}>
                        <TwLoadingIcon />
                      </div>
                    ) : (<>
                      <UploadCloud className="h-6 w-6" />
                      <p className="text-sm">Click or drag an image here to upload</p>
                      <p className="text-sm">JPEG, PNG, GIF up to 5MB</p>
                    </>)}
                    <input {...getInputProps()} />
                    {uploadedFile && (
                      <p className="mt-2 text-xs text-gray-600">Uploaded: {uploadedFile.name}</p>
                    )}
                  </div>
                </div>
              );
            }}
          </Dropzone>

        </div>
      ) : (variant === "profile" ? (
        <div className="w-full sm:w-full sm:max-w-sm md:max-w-lg flex flex-col gap-2">
          <Dropzone
            accept={acceptImageType}
            noDrag={true}
            onDrop={async (files) => {
              const errors = {};
              if (files[0]) {
                const file = files[0];
                uploadeMediaToServer(file);
                return;
              } else {
                setUploadedFile("");
                setImageUrl("");
                if (onChange) onChange("")
                errors[name] = "Only PNG and JPG formats are allowed";
              }
              // setFormErrors({ ...errors });
            }}
          >
            {({ getRootProps, getInputProps }) => {
              return (
                <div
                  {...getRootProps({ className: "dropzone" })}
                  className="col-span-full flex items-center gap-x-8">
                  {loading ? (
                    <div className={"size-24 grid place-items-center"}>
                      <TwLoadingIcon />
                    </div>
                  ) : (imageUrl ? (
                    <img src={imageUrl} alt="Preview" className="size-20 flex-none rounded-lg [bg-gray-200] bg-[#F3F4F6] object-cover" />
                  ) : (
                    <img src={defaultValue || default_business_logo_placeholder} alt="Preview" className="size-24 flex-none rounded-lg [bg-gray-200] bg-[#F3F4F6] object-cover" />
                  ))}
                  <div>
                    <input {...getInputProps()} />
                    <TwButton className="!rounded-md px-3 py-2">{uploadBtnText}</TwButton>
                    <p className="mt-2 text-xs/5 text-gray-400">JPG, GIF or PNG. 1MB max.</p>
                  </div>
                </div>
              );
            }}
          </Dropzone>

        </div>
      ) : (<>
        <TabGroup>
          <TabList className="flex space-x-1 rounded-md bg-gray-100 p-1">
            {tabs.map(({ name, icon: Icon }) => (
              <Tab
                key={name}
                className={({ selected }) =>
                  classNames(
                    "flex items-center gap-2 w-full justify-center rounded-md py-2 text-sm font-medium",
                    selected
                      ? "bg-white shadow text-blue-600"
                      : "text-gray-500 hover:bg-white"
                  )
                }
              >
                <Icon className="w-4 h-4" />
                {name}
              </Tab>
            ))}
          </TabList>

          <TabPanels className="mt-2">
            <TabPanel>
              <input
                type="text"
                value={uploadedFile ? "" : imageUrl}
                onChange={(e) => {
                  setImageUrl(e.target.value.trim());
                  setUploadedFile(null);
                  if (onChange) onChange(e.target.value.trim())
                }}
                placeholder="https://example.com/image.jpg"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              />
            </TabPanel>

            <TabPanel>
              <Dropzone
                accept={acceptImageType}
                noDrag={true}
                onDrop={async (files) => {
                  const errors = {};
                  if (files[0]) {
                    const file = files[0];
                    uploadeMediaToServer(file);
                    return
                  } else {
                    setUploadedFile("");
                    setImageUrl("");
                    if (onChange) onChange("")
                    errors[name] = "Only PNG and JPG formats are allowed";
                  }
                  // setFormErrors({ ...errors });
                }}
              >
                {({ getRootProps, getInputProps }) => {
                  return (
                    <div
                      {...getRootProps({ className: "dropzone" })}
                      className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center bg-gray-50 hover:bg-gray-100 transition cursor-pointer flex flex-col gap-2 items-center justify-center"
                    >
                      {loading ? (
                        <div className={"h-28 w-full grid place-items-center"}>
                          <TwLoadingIcon />
                        </div>
                      ) : (<>
                        <UploadCloud className="h-6 w-6 text-gray-500" />
                        <p className="text-sm text-gray-500">Click or drag an image here to upload</p>
                        <p className="text-sm text-gray-500">JPEG, PNG, GIF up to 5MB</p>
                      </>)}
                      <input {...getInputProps()} />
                      {uploadedFile && (
                        <p className="mt-2 text-xs text-gray-600">Uploaded: {uploadedFile.name}</p>
                      )}
                    </div>
                    // <div
                    //   {...getRootProps({ className: "dropzone" })}
                    //   className={"max-h-44"}
                    // >
                    //   <div
                    //     className={`p-2 border-dashed border-2 max-w-sm sm:max-w-lg min-h-40 rounded-xl flex flex-col justify-center items-center ${photo ? "border-0" : "bg-white"
                    //       } ${errors[name] ? "border-red-500" : ""}`}
                    //   >
                    //     <div className={`grid grid-cols-2 w-full`}>
                    //       {photo != "" ? (
                    //         <img
                    //           className={
                    //             "max-w-[340px] max-h-40 rounded-xl object-cover"
                    //           }
                    //           src={photo}
                    //           alt={`Your Topic Photo`}
                    //         />
                    //       ) : (<img
                    //         className={
                    //           "[max-w-sm] max-h-40 rounded-xl object-cover"
                    //         }
                    //         src={defaultImage}
                    //         alt={`Your Topic Photo`}
                    //       />)}
                    //       <div className="flex flex-col justify-center items-center ">
                    //         <div className="flex justify-center items-center w-4/5">
                    //           <div className="flex-none">
                    //             <img
                    //               className={""}
                    //               src={uploadImage}
                    //               alt={""}
                    //             />
                    //           </div>
                    //           <div className="flex-1 pl-2">
                    //             <div className="text-[#33BE97]">Click here </div>
                    //             <div>
                    //               to upload Image
                    //             </div>
                    //           </div>
                    //         </div>
                    //         <div className="w-full" sx={{ color: "#33BE97" }}>
                    //           <LinearProgressWithLabel color="progress" variant="determinate" value={imageProgress} />
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    //   <input {...getInputProps()} />
                    // </div>
                  );
                }}
              </Dropzone>
            </TabPanel>
          </TabPanels>
        </TabGroup>

        {/* Preview */}
        <div className={classNames("border [border-gray-200] rounded-md p-4 bg-gray-50", inputClass)}>
          <p className="text-sm font-medium mb-2">Image Preview</p>
          <div className="w-full aspect-[2/1] bg-gray-100 flex items-center justify-center overflow-hidden rounded-md">
            {imageUrl ? (
              <img src={imageUrl} alt="Preview" className="object-contain h-full w-full" />
            ) : (
              <img src={defaultValue || defaultImagesvg} alt="Preview" className="object-contain h-full w-full" />
              // <span className="text-gray-400 text-sm">No image selected</span>
            )}
          </div>
        </div>
      </>)))}
      {errors[name] && (
        <TwFormHelperText error={errors[name] != ""}>{errors[name]}</TwFormHelperText>
      )}
    </div>
  );
}
